import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUser } from '../../connection/socket';
import { Profile } from '../../stores/reducers/invitations';
import { getNameOrInitials } from '../../utils/utils';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { DRAG_TYPE } from '../../stores/reducers/user-interface';
import useDragItem from '../../hooks/use-dnd/use-drag-item';
import useProfile from '../../hooks/use-profile';

interface Props {
	connectedPresenter?: ConnectedUser;
	invitedPresenter?: Profile;
	isOnCanvas: boolean;
}

export default function ScreenShareLink(props: Props) {
	const host = useSelector((state: any) => state.SessionReducer.host);

	const {
		connectedPresenter,
		invitedPresenter,
		isOnCanvas,
	} = props;

	const presenter = useMemo(() => {
		if (connectedPresenter) {
			return connectedPresenter;
		} if (invitedPresenter) {
			return invitedPresenter;
		}
		return {
			email: '',
			first_name: '',
			last_name: '',
			avatar: '',
			poster: '',
			job_title: '',
			gr_user: 0,
		} as Profile;
	}, [connectedPresenter, invitedPresenter]);

	const {watchedProfile} = useProfile({suggestedProfile: presenter.gr_user})

	const { dragRef, isDragging } = useDragItem(
		{ id: presenter?.email, type: DRAG_TYPE.FEED_SCREENSHARE },
		host,
	);

	return (
		<React.Fragment>
			{isDragging && (<div className="media-link-drag-placeholder" />)}
			<div
				className={classNames('padding-top-small', {
					'link-is-highlighted': isOnCanvas,
					'link-is-dragging': isDragging,
				})}
			>
				<div
					className={classNames('media-link padding-medium screenshare', {
						'cursor-grab': host,
					})}
					onFocus={(e) => e.currentTarget.blur()}
					ref={dragRef}
				>
					<div className="media-details screenshare">
						<Icon name={ICONS.SHARE_SCREEN} color={COLORS.WHITE} size={30} className='padding-right-small'/>
						<div className="media-details-metadata">
							<p className="media-title bl-font-s3">{getNameOrInitials(watchedProfile, true)}</p>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}
